import gql from 'graphql-tag';

export const CREATE_DEAL_BUILDER_PROPOSAL = gql`
  mutation CreateDealBuilderProposal($proposalId: ID!, $input: CreateProposalV2Input!) {
    dealBuilder {
      createDealBuilderProposal(proposalId: $proposalId, input: $input) {
        id
        success
        errorMessage
      }
    }
  }
`;
